import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useLanguagePreferences } from '@/hooks/useLanguagePreferences';

export const EnhancedLanguageSwitcher = () => {
  const { t } = useTranslation('common');
  const { currentLanguage, changeLanguage, isSaving } = useLanguagePreferences();

  return (
    <Select 
      value={currentLanguage} 
      onValueChange={changeLanguage}
      disabled={isSaving}
    >
      <SelectTrigger className="w-[100px]">
        <SelectValue placeholder={t('language')} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">{t('english')}</SelectItem>
        <SelectItem value="es">{t('spanish')}</SelectItem>
      </SelectContent>
    </Select>
  );
};
